import { ONBOARDING_PATHS } from './paths';
import type { OnboardingState } from './redirects';

export type OnboardingEntryInput = OnboardingState & {
  /** The answers read failed, so `hasAnswered` is a guess. */
  hasUntrustedSignal: boolean;
};

/**
 * Where to send a user landing outside `/onboarding/*`, or `null` to leave
 * their normal destination alone. Never returns `'/'`: called from the root
 * page, that would self-navigate and clobber the workspace redirect.
 */
export function selectOnboardingEntryRedirect(input: OnboardingEntryInput): string | null {
  const { isEligible, isChecklistCohort, isComplete, hasAnswered, isAiEnabled, hasUntrustedSignal } = input;

  if (hasUntrustedSignal) {
    return null;
  }
  if (!isEligible || isComplete || hasAnswered) {
    return null;
  }
  if (isAiEnabled) {
    return ONBOARDING_PATHS.wizard;
  }
  // No wizard without AI: the checklist cohort still has its static question,
  // and nobody else has anything waiting for them.
  return isChecklistCohort ? ONBOARDING_PATHS.getStarted : null;
}
